import { AUDIO_EXTENSIONS, LOCAL_AUDIO_EXTENSION } from '@utils/audioFormats';

export const TOPIC = {
    product: 'Продукт: ',
    service: 'Услуга: ',
    custom: '',
    status: 'Статус: ',
};

export const replyCommentInitialData = {
    recipient: null,
    message: null,
    topic: null,
    messageId: null,
};

/** Пауза в наборе, после которой поиск по чату уходит на сервер. */
export const SEARCH_DEBOUNCE_MS = 500;

/** Сколько сообщений в одной порции: открываем чат на последней странице. */
export const CHAT_PAGE_SIZE = 20;

export const FILTER_KEYS = {
    FILE: 'files',
    MEMBER: 'recipients',
    TOPIC: 'topics',
    DATE: 'date',
    SEARCH: 'search',
};

export const acceptedFormats = 'image/*, video/*, .heic, .pdf, .doc, .docx, .xls, .xlsx';

export const FILES_GROUP = {
    ALL: 'Все',
    WORD: 'Word',
    EXCEL: 'Excel',
    VIDEO: 'Видео',
    AUDIO: 'Голосовые',
    IMAGE: 'Фото',
    PDF: 'Pdf',
};

/**
 * Все аудиоконтейнеры разом — иначе фильтр «Голосовые» пропускал бы записи: до этого
 * в карте лежал только локальный ключ `audio`, а пришедшие с сервера `wav`/`webm`
 * не попадали никуда.
 */
const AUDIO_FILE_FORMATS = AUDIO_EXTENSIONS.reduce<Record<string, string>>(
    (formats, extension) => ({ ...formats, [extension]: FILES_GROUP.AUDIO }),
    { [LOCAL_AUDIO_EXTENSION]: FILES_GROUP.AUDIO }
);

export const GROUPED_FILE_FORMATS = {
    // Изображения
    jpg: FILES_GROUP.IMAGE,
    jpeg: FILES_GROUP.IMAGE,
    gif: FILES_GROUP.IMAGE,
    web: FILES_GROUP.IMAGE,
    png: FILES_GROUP.IMAGE,
    apng: FILES_GROUP.IMAGE,
    avif: FILES_GROUP.IMAGE,

    // Word
    doc: FILES_GROUP.WORD,
    docx: FILES_GROUP.WORD,

    // Excel
    xls: FILES_GROUP.EXCEL,
    xlsx: FILES_GROUP.EXCEL,

    // Pdf
    pdf: FILES_GROUP.PDF,

    // Audio
    ...AUDIO_FILE_FORMATS,
};

export const FORMATS = {
    IMAGE: 'IMAGE',
    PDF: 'PDF',
    WORD: 'WORD',
    EXCEL: 'EXCEL',
    UNSUPPORTED: 'UNSUPPORTED',
    VIDEO: 'VIDEO',
};


export const EXTENSIONS_DATA = {
    // ИЗОБРАЖЕНИЯ
    jpeg: FORMATS.IMAGE,
    jpg: FORMATS.IMAGE,
    png: FORMATS.IMAGE,
    gif: FORMATS.IMAGE,
    svg: FORMATS.IMAGE,
    avif: FORMATS.IMAGE,
    apng: FORMATS.IMAGE,
    webp: FORMATS.IMAGE,
    heic: FORMATS.IMAGE,

    // PDF
    pdf: FORMATS.PDF,

    // WORD
    doc: FORMATS.WORD,
    docx: FORMATS.WORD,

    // EXCELL
    xls: FORMATS.EXCEL,
    xlsx: FORMATS.EXCEL,

    // ВИДЕО определяется не здесь, а `getMediaKind` (`@utils/mediaKind`): по MIME
    // и расширению без учёта регистра

    // БЕЗ ПОДДЕРЖКИ
    UNSUPPORTED: FORMATS.UNSUPPORTED,
};

export const TOPIC_CLASSNAMES = { 
    custom: 'App\\Models\\Api\\V1\\Chats\\ChatMessageTopic',
    product: 'App\\Models\\Api\\V1\\Product',
    service: 'App\\Models\\Api\\V1\\Service',
    task: 'App\\Models\\Api\\V1\\Task\\Task',
};
